import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import leadSaga from './leads/saga'

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    leadSaga(),
  ]);
}
